// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dx-card {
  padding: 10px;
  width: 330px;
  margin: auto auto;
}
:host-context(.screen-x-small) .dx-card {
  width: 100%;
  height: 100%;
  border-radius: 0;
  box-shadow: none;
  margin: 0;
  border: 0;
}
.dx-card .content {
  padding: 40px;
}

.login-card-container {
  min-height: 100vh;
  min-width: 100vw;
}
.login-card-container .login-card-body {
  width: 400px;
  margin: 0 auto;
  padding: 50px 0 150px;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,YAAA;EACA,iBAAA;AAAJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,SAAA;AAAN;AAGI;EACE,aAAA;AADN;;AAKA;EACI,iBAAA;EACA,gBAAA;AAFJ;AAII;EACI,YAAA;EACA,cAAA;EACA,qBAAA;EACA,YAAA;AAFR","sourcesContent":["  \n  .dx-card {\n    padding: 10px;\n    width: 330px;\n    margin: auto auto;\n  \n    :host-context(.screen-x-small) & {\n      width: 100%;\n      height: 100%;\n      border-radius: 0;\n      box-shadow: none;\n      margin: 0;\n      border: 0;\n    }  \n    \n    .content {\n      padding: 40px;\n    }  \n  }\n\n.login-card-container {\n    min-height: 100vh;\n    min-width: 100vw;\n\n    .login-card-body {\n        width: 400px;\n        margin: 0 auto;\n        padding: 50px 0 150px;\n        height: 100%;\n      }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
